define('views/modules/calendar/animated-session/exercise/lists/exercise-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'sortable', 'utils',
    // events
    'services/events/animated-session-events',
    // services
    'services/viewport',
    // model
    'models/calendar/session/exercise/exercise',
    // views
    'views/modules/calendar/animated-session/exercise/lists/exercise-list-item',
    'views/modules/calendar/animated-session/exercise/lists/exercise-list-placeholder',
    'views/modules/calendar/animated-session/exercise/lists/exercise-separator',
    // modal views
    'views/modules/calendar/animated-session/animation/animation-detail-modal',
    'views/modules/calendar/animated-session/exercise/exercise-duplicate-modal',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/lists/exercise-list.html'
], function(
    // Libs
    _, Backbone, Mustache, Sortable, U,
    // events
    AnimationEvents,
    // services
    Viewport,
    // model
    MExercise,
    // views
    VExerciseListItem,
    VExerciseListPlaceholder,
    VExerciseSeparator,
    // modal views
    VAnimationDetailModal,
    VExerciseDuplicateModal,
    // templates
    TSessionExerciseList

) {

    // TODO : We need to review the way exercicses are displayed
    var VExerciseList = Backbone.View.extend({
        exerciseView: VExerciseListItem,
        className: "exercise-list-root",
        template: TSessionExerciseList,
        events: {
            "click .load-more-button": "onLoadMore",
        },
        regions: {
            list: ".session-edit-list",
            addexercise: ".add-exercise",
            more: ".load-more-button",
        },
        defaults: {
            renderItemCount: 8,
            chunkSize: 4,
            moreChunkSize: 4,
        },

        initialize: function(opt) {
            this.options = _.extend({}, {
                sortable: true,
                resetCollection: true
            }, opt);

            this._initLoadMore();

            _.extend(this, {
                role: opt.role,
                view: {
                    placeholder: new VExerciseListPlaceholder({
                        collection: this.collection,
                    })
                }
            });

            this.listenTo(this.collection, {
                "exercise:detail": this.onExerciseDetail,
                "exercise:duplicate": this.onDuplicateExercise,
                "update": this.onExerciseListUpdate,
                "remove": this.onRemoveExercise,
                "reset": this.onCollectionReset,
                "move:up move:down": this.moveExercise,
            });
        },

        initListener: function() {
            this.stopListeningTo(AnimationEvents);
            this.listenTo(AnimationEvents, {
                'exercise:add:animation': this.onAddAnimations,
                "exercise:drag:animation": this.onAnimationDrag,
                "exercise:drag:animation:end": this.onAnimationDragEnd,
            });
            // listen to changes on the number of week for the session
            var collection = this.collection;
            collection.stopListeningTo(this.model);
            collection.listenTo(this.model, {
                'change:num_weeks': collection.onWeekChange,
            });
        },

        render: function() {
            //This condition fix this bug! Calendrier: Si tu passes de l'interface seance anime ds le calendrier, a celle des templates, les exercices de l'un se retrouve ds l'autre
            // if (this.options.resetCollection && this.model.isNew())
            //     this.collection.reset(undefined, { silent: true });

            this.initListener();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();

            if (!Viewport.isMobile() && this.options && this.options.sortable) {
               this._initSortable(this.zone.$list);
           }

            this.reset();

            return this;
        },

        reset: function() {
            this.scrollEnable = false;
            var $list = this.zone.$list.empty();
            if (this.options && !this.options.summary) {
                $list.append(this.view.placeholder.render().el);
            }

            this.toggleAddExercisePlaceholder();
            this.removeChildViews({ defer: true });
            this._initLoadMore();
            this.addAllExercise();
        },

        addAllExercise: function(models) {
            if (!this.zone) return;

            var collection = models || this.collection.toArray();

            var delay = 50,
                count = 1,
                chunkSize = this.defaults.chunkSize,
                container = document.createDocumentFragment();

            // TODO: Defering exercises display with chunkSize
            // _(collection).chain().first(chunkSize).each(function(model) {
            //     container.appendChild(this.addExercise(model, delay * count, false).el);
            //     container.appendChild(this.addSeparator(model, false).el);
            //     count++;
            // }, this);

            _.each(collection, function(model) {
                container.appendChild(this.addExercise(model, delay * count, false).el);
                container.appendChild(this.addSeparator(model, false).el);
                count++;
            }, this);

            this.append(container);

            this.scrollToLast();

            // if (collection.length > chunkSize && this.itemRendered < this.renderItemTarget) {
            //     var rest = _.rest(collection, chunkSize);
            //     this.addAllExercise(rest);
            //     // _.defer(this.addAllExercise.bind(this), rest);
            // } else {
            //     this.onAddedAllExercise();
            // }

            this.onAddedAllExercise();
        },

        addExercise: function(model, delay, render) {
            var view = new this.exerciseView({
                role: this.role,
                model: model,
                viewport: this.regions.list,
                item: this.options ? this.options.item : null,
                summary: this.options ? this.options.summary : null,
            });
            this.childViews.push(view);
            view.render();

            if (delay > 0) {
                view.$el.addClass("transparent");

                _.delay(function() {
                    view.$el.removeClass("transparent");
                }, delay);
            }

            // early return the content
            if (render !== false) {
                this.append(view.el);
                this.addSeparator(model);
            }

            this.itemRendered++;

            return view;

        },

        addSeparator: function(model, render) {
            var view = new VExerciseSeparator({
                model: model,
                role: this.role
            });

            this.childViews.push(view);
            view.render();

            if (render !== false) this.append(view.el);
            return view;
        },

        append: function(element) {
            if (this.options.summary) {
                this.zone.$list.append(element);
            } else {
                this.view.placeholder.$el.before(element);
            }
        },

        _initLoadMore: function() {
            this.itemRendered = 0;
            this.renderItemTarget = this.defaults.renderItemCount;
        },

        _updateLoadMoreButton: function(val) {
            if (_.isUndefined(val)) val = this.itemRendered < this.collection.length;
            this.zone.$more.toggleClass("hidden", !val);
        },

        scrollToLast: function() {
            if (this.zone && this.scrollEnable) {

                var $lastExercise = this.zone.$list.children('.exercise').last();
                if ($lastExercise.length > 0) {
                    $lastExercise[0].scrollIntoView();
                }
            }
        },

        updateWeek: function() {
            this.collection.onWeekChange(this.model, this.model.getWeekCount());
            return this;
        },

        _initSortable: function($elem) {
            this.sortable = Sortable.create($elem, _.extend({
                group: {
                    name: "exercises",
                    pull: false,
                    put: ['animation']
                },
                delay: Viewport.width() <= 768 ? 50 : 0,
                handle: ".handle",
                onEnd: this.onDragEnd,
                onMove: this.onDragMove,
                context: this,
            }, this.sortableOptions));
        },

        toggleAddExercisePlaceholder: function() {
            var placeholderView = null;
            if (this.view && this.view.placeholder)
                placeholderView = this.view.placeholder;

            if (placeholderView) {
                placeholderView.toggle(this.collection.length > 0);
            }
        },

        /////////////////////
        // sortable events //
        /////////////////////
        // dragging ended
        onDragEnd: function(e) {
            this.onAfterDragAndDrop();
        },

        // Event when you move an item in the list or between lists
        onDragMove: function(e) {
            var $rel = this.$(e.related);
            // ignore when hovering seperator and the placeholder button.
            if (this.sortable && this.sortable.isFiltered($rel)) {
                return false;
            }

            this.moveExercise(this.$(e.dragged), $rel);

            return false; // cancel default move behavior
        },

        /**
         * Swap exercises DOM elements.
         * @param  {jQuery} $source exercise to move.
         * @param  {jQuery} $target exercise to insert before or after.
         */
        moveExercise: function($source, $target) {

            if ($source.get(0) === $target.get(0)) return;

            if (!this.movingExercises) {

                this.movingExercises = true;

                var oldIndex = $source.index() / 2,
                    // make sure to bring the seperator element when moving an exercise
                    $el = $source.add($source.next()),
                    sourceRect = $source.get(0).getBoundingClientRect(),
                    targetRect = $target.get(0).getBoundingClientRect();

                // moving of elements
                if ($source.index() < $target.index()) {
                    $target.next().after($el);
                } else {
                    $target.before($el);
                }

                // update the position in the collection for the ordering to persist.
                this.collection.move(oldIndex, $source.index() / 2);

                var sortable = this.sortable;
                if (sortable) {
                    sortable._animate(sourceRect, $source.get(0));
                    sortable._animate(targetRect, $target.get(0));

                    _.delay(function() {
                        this.movingExercises = false;
                    }.bind(this), this.sortable.options.animation * 2);
                } else {
                    this.movingExercises = false;
                }
            }

        },

        /**
         * When an animation is dragged onto this exercise list.
         */
        onAnimationDrag: function(animation, e) {
            var $rel = this.$(e.related),
                isPlaceholder = $rel.hasClass("add-exercise");

            // Add a new exercise to the list if the target is the placeholder.
            // This is important when the list is empty.
            if (this.sortable && this.sortable.isFiltered($rel) && !isPlaceholder) {
                return false;
            }

            if (!this.draggedAnimation) {
                var model = this.collection.add(MExercise.createFromAnimation(animation), {
                    silent: true,
                    at: this.itemRendered
                });

                this.collection.updatePositions();

                this.updateWeek()
                    .toggleAddExercisePlaceholder();

                this.draggedAnimation = this.addExercise(model);
                if (this.sortable) {
                    this.sortable.toggleClass(this.draggedAnimation.$el, true);
                }

                //_.defer(this.onAddedAllExercise.bind(this));
                this.onAddedAllExercise();
            }
            if (!isPlaceholder) {
                this.moveExercise(this.draggedAnimation.$el, $rel);
            }

        },

        /**
         * When an animation is released onto this exercise list.
         */
        onAnimationDragEnd: function(e) {
            if (this.sortable && this.draggedAnimation) {
                this.sortable.toggleClass(this.draggedAnimation.$el, false);
            }

            this.draggedAnimation = undefined;

            this.onAfterDragAndDrop();
        },

        /**
         * After a completed drag & drop.
         * Cleanup.
         */
        onAfterDragAndDrop: function() {
            if (!this.collection.isEmpty()) {
                this.collection.last().toggleLink(false);
            }
        },

        ////////////
        // events //
        ////////////
        onAddAnimations: function(animations, options) {
            this.collection.pushAnimation(animations, options);
            this.updateWeek();
        },

        onAddedAllExercise: function() {
            this.scrollEnable = true;

            this._updateLoadMoreButton();
        },

        onCollectionReset: function() {
            if (this.zone) {
                //_.defer(this.reset.bind(this));
                this.reset();
            }
        },

        onRemoveExercise: function(model, collection, options) {
            this.itemRendered--;
        },

        onLoadMore: function(e) {
            this.renderItemTarget += this.defaults.moreChunkSize;
            _.defer(this.addAllExercise.bind(this), this.collection.rest(this.itemRendered));
        },

        onExerciseListUpdate: function(collection, options) {
            this.toggleAddExercisePlaceholder();

            if (options.changes.added.length > 0) {
                this.renderItemTarget = this.collection.length;
                this.addAllExercise(this.collection.rest(this.itemRendered));
                // _.defer(this.addAllExercise.bind(this), this.collection.rest(this.itemRendered));
            }
        },

        onExerciseDetail: function(model) {
            var animation = model.getAnimation();
            if (!animation) return;

            if (!this.view.detail) {
                this.view.detail = new VAnimationDetailModal();
            }
            this.view.detail.setTCNotesDisplay(!model.get("hideTCNotes"), model.get("notes"));
            this.view.detail.setModel(animation).render();
        },

        onDuplicateExercise: function(model) {
            var animation = model.getAnimation();
            if (!animation) return;

            if (!this.view.duplicate) {
                this.view.duplicate = new VExerciseDuplicateModal();
            }
            this.view.duplicate.resetModal(model, this.collection.models);
        },

        onDisable: function() {
            this.stopListeningTo(AnimationEvents);
            _.each(this.childViews, function(view) {
                _.delay(view.remove.bind(view), 1000);
            });
        },

    });

    return VExerciseList;

});

